import { useTranslation } from 'react-i18next';

import PlusIcon from '@crm/shared/assets/icons/plus.svg?react';
import { cn } from '@crm/shared/lib';
import { Button, SvgIcon } from '@crm/shared/ui';

type TAddColumnBtnProps = {
    onClick: () => void;
};

export const AddColumnBtn = ({ onClick }: TAddColumnBtnProps) => {
    const { t } = useTranslation();

    return (
        <Button
            className={cn(
                'group flex size-11 flex-none items-center justify-center gap-0 overflow-hidden rounded-[10px] bg-blue-50 p-2.5 hover:gap-2'
            )}
            onClick={onClick}
            title={t('crm.deals.board.column.add')}
        >
            <SvgIcon
                icon={PlusIcon}
                className="size-4 text-smtr-main-accent-100 transition-colors group-hover:text-white"
            />
        </Button>
    );
};
